import React, { useEffect, useRef, useState } from "react";
import Videojs from "../../video-js";
import classNames from "classnames";
import Image from "../../../elements/image";
import { mobileIs } from "../../../utils/siteUtils";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
const ImageOverlayImage = props => {
  const  { index, item } = props;
  const rootEl = useRef();
  const videoEl = useRef();
  const [active, setActive] = useState(false);
  const isMobile = mobileIs();
  const image = isMobile ? item?.fields?.bannerMobile?.value : item?.fields?.banner?.value;
  const video = isMobile ? item?.fields?.videoMobile?.value : item?.fields?.video?.value;
  const videoOptions =
    video
      ? {
          sources: [
            {
              src: video.src,
              type: video.mimeType
            }
          ],
          poster: image.src,
          videoTitle: '',
          autoplay: item?.fields?.autoPlay.value,
          controls: true,
          muted: true,
					loop: true
        }
      : {};
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    }
  }, []);
  const onScroll = () => {
    if(rootEl.current){
      let top = rootEl.current.getBoundingClientRect().top;
      let height = rootEl.current.getBoundingClientRect().height;
      let winHeight = window.innerHeight;
      if( top < ( winHeight - height/2)){
        setActive(true)
      }
      if( top > winHeight && top > 0){
        setActive(false)
      }
    }
  }
  const videoLoaded = _ => {
    if(item?.fields?.autoPlay.value){
      videoEl.current && videoEl.current.player.play()
    }
  }
  return (
    <div key={index} ref={rootEl} className={classNames("image-overlay-list-item", active ? 'active' : null)} >
        { !video &&
          <Image className="image" { ... isMobile ? item?.fields?.bannerMobile?.value :item?.fields?.banner?.value} />
        }
        {/* ideoPlayPressed={videoPlayStart}  */}
        { video && 
          <Videojs ref={videoEl} videoLoaded={videoLoaded} {...videoOptions}/>
        }
        
        <RichText className="title"  field={isMobile ? item?.fields?.mobileTitle : item?.fields?.title} />
        {!isMobile && 
          <RichText className="content"  field={item?.fields?.content} />
        }
    </div>
  )
};
export default ImageOverlayImage;
